export const SET_ANSWERS = 'SET_ANSWERS'
export const SET_FORWARDED = 'SET_FORWARDED'